import { CreateWorksheetSelector } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import * as objectPath from '../../../../Lib/Object/Path/Immutable';

/**
 * @deprecated Use createLimitSelector instead
 */
export const getLimitForPath = (worksheet: any, path: string) => {
  let pathArray = path.split('.');
  const propName = pathArray.pop();
  pathArray.push('Limits');

  const limits = objectPath.get(worksheet, pathArray.join('.'))?.filter((m: any) => m.PropertyName === propName);

  if (limits && limits.length > 1) throw new Error(`Multiple limits found for path ${path}.`);

  return limits && limits[0];
};

export const createLimitSelector = (createWorksheetSelector: CreateWorksheetSelector, path: string) => {
  let pathArray = path.split('.');
  const propName = pathArray.pop();
  pathArray.push('Limits');

  return pipe(createWorksheetSelector(pathArray.join('.')), (allLimits) => {
    const limits = allLimits?.filter((l: any) => l.PropertyName === propName);
    if (limits && limits.length > 1) throw new Error(`Multiple limits found for path ${path}.`);
    return limits?.[0];
  });
};
